import React, {Component} from 'react';
import {Dropdown, MenuItem} from "react-bootstrap";
import {findDOMNode} from 'react-dom';
import {boundMethod} from 'autobind-decorator';
import CompanySwitcherToggle from '@legacy/components/common/CompanySwitcher/Toggle';
import CompanySwitcherOverlay from '@legacy/components/common/CompanySwitcher/Overlay';
import CompanyHelper from '@legacy/helpers/companyHelper.js.es6';
import typeUtils from '@legacy/helpers/utils/typeUtils.js.es6';
let body = null;

/**
 * MAIN CompanySwitcher component class
 * @type {CompanySwitcher}
 */
const CompanySwitcher = class CompanySwitcher extends Component {

    constructor(props){
        super(props);
        const { setAsync, setIsLoading } = props;

        this._isOpen = false;

        /* Investigate why we do this here as part of Redux refactor. */
        if(typeUtils.isFunction(setAsync)){ setAsync(true); }
        if(typeUtils.isFunction(setIsLoading)){ setIsLoading(true); }

        /** Refs **/
        this.ToggleControl = null;
        this.SwitcherOverlay = null;

        body = document.querySelector('body');
    }

    componentDidMount(){
        const { user, fetchCompanies } = this.props;

        body?.addEventListener('click', this._rootClose);
        fetchCompanies(user);
    }

    componentWillUnmount(){
        body?.removeEventListener('click', this._rootClose);
    }

    @boundMethod
    _rootClose(e){
        const container = body.querySelector('.vst-user__company-select-container');

        if(container){
            if(!container.contains(e.target) && this._isOpen){
                this._getHTMLLinkElement().click();
            }
        }
    }

    @boundMethod
    _onSelect(eventKey, e){
        const { recentCompanies, setIsLoading, setSelectedCompany } = this.props;

        e.preventDefault();
        if(typeUtils.isFunction(setIsLoading)){ setIsLoading(true); }
        setSelectedCompany(eventKey, recentCompanies)
            .then(() => {
                this._getHTMLLinkElement().click();
            });
    }

    @boundMethod
    _onOverlayToggle(isOpen){
        const { recentCompanies, setRecentCompanies } = this.props;

        this._isOpen = isOpen;
        if(!isOpen){
            this._getHTMLInputElement().value = '';
            setRecentCompanies(recentCompanies);
        }
    }

    @boundMethod
    _getHTMLInputElement(){
        return findDOMNode(this.SwitcherOverlay).querySelector('#vstUserCompanyFilterInputField');
    }

    @boundMethod
    _getHTMLLinkElement(){
        return findDOMNode(this.ToggleControl);
    }

    render(){
        const { companies, show, shouldHide, selectedCompany } = this.props;

        return show ? (
            <Dropdown
                dropup id="vstCompanySwitcher"
                className={"vst-user__company-select-container" + (shouldHide === true ? " hide-offscreen" : "")}
                onToggle={ this._onOverlayToggle }>
                <CompanySwitcherToggle
                    ref={(c) => { if(c !== null){ this.ToggleControl = c; } }}
                    bsRole="toggle"
                />
                <CompanySwitcherOverlay
                    ref={(c) => { if(c !== null){ this.SwitcherOverlay = c; } }}
                    onSelectVST={ this._onSelect }
                    bsRole="menu"
                    { ...this.props }
                    toggleButton={ this._getHTMLLinkElement }>
                    {
                        companies.map((company, index) => (
                                <MenuItem
                                    key={ index }
                                    href={ ('/users/companies/' + company.id) }
                                    eventKey={ company.id }
                                    onSelect={ this._onSelect }
                                    disabled={ CompanyHelper.isDisabled(company, selectedCompany) }
                                    className={ (CompanyHelper.isDisabled(company, selectedCompany) ? 'vst-company-link--disabled' : '') }>
                                    { company.name }
                                </MenuItem>
                            )
                        )
                    }
                </CompanySwitcherOverlay>
            </Dropdown>
        ) : null;
    }

};

export default CompanySwitcher;
